/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from 'react';

import { Formik } from 'formik';
import { Checkbox, FormControlLabel, Switch } from '@mui/material';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { FORM_DEBOUNCE_TIME } from '../../../../../config/deviceConfig/Values';

import { IDFField } from '../../../../../config/deviceConfig/types';
import { ITEM_DEFAULTS } from '../../../../../config/deviceConfig/item_defaults';
import { IFormResetRef, FormResetAction } from '../../../ProDeviceCreateEdit/types';

const conButtonsTypesOfAlarms = ['show_arm_away', 'show_arm_home', 'show_panic', 'show_disarm'];

const FIELD_NAME = ITEM_DEFAULTS.ITEM_CREATOR.DEVICE_FIELDS.state_checkbox;
type ComponentProps = {
  fieldConfig: IDFField;
  validateForm: number;
  deviceInfo: any;
  resetForm: IFormResetRef;
  onChange: (payload: any, isInitializing?: boolean) => void;
};
interface IformData {
  state_checkbox: boolean;
}
// eslint-disable-next-line import/prefer-default-export
export const ProDeviceFieldStateCheckbox: React.FunctionComponent<ComponentProps> = (props) => {
  const [deb, setDeb] = useState<BehaviorSubject<{values: IformData; errors: any} | null>>();
  const [switchVal, setSwitchVal] = useState(typeof props.fieldConfig?.default === 'boolean' ? props.fieldConfig?.default : true);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onSubmitForm = (formData: IformData) => {};

  const sendDefaults = () => {
    if (!props.fieldConfig || !deb) {
      return;
    }
    deb.next({
      values: {
        state_checkbox: props.fieldConfig.default,
      },
      errors: {},
    });
  };

  /**
   * Resetting or changing form data from parent
   */
  const refFormReset = useRef<IFormResetRef>({
    ref: 0,
    action: '',
    info: {},
  });
  useEffect(() => {
    if (
      formRef.current
      && props.resetForm.ref > 0
      && props.resetForm.ref > refFormReset.current.ref
    ) {
      refFormReset.current = props.resetForm;
      if (props.resetForm.action === FormResetAction.toCurrentInfo) {
        const values = props.resetForm.info.settings[props.fieldConfig.field];
        setSwitchVal(typeof values === 'boolean' ? values : true);
        formRef.current.setValues({
          state_checkbox: values,
        });
      } else {
        formRef.current.resetForm();
      }
    }
  }, [props.resetForm]);

  const initilized = useRef(0);

  useEffect(() => {
    const b = new BehaviorSubject<{values: IformData; errors: any} | null>(null);
    setDeb(b);
    const sub = b
      .pipe(
        debounceTime(FORM_DEBOUNCE_TIME),
        map((v) => JSON.stringify(v)),
        distinctUntilChanged(),
        map((v) => JSON.parse(v)),
      )
      .subscribe((v: {values: IformData; errors: any} | null) => {
        if (v == null || props.fieldConfig == null) {
          return;
        }

        const { values, errors } = v;
        const infoData: any = {
          settings: {},
        };

        if (
          conButtonsTypesOfAlarms.includes(props.fieldConfig.field)
          && typeof values.state_checkbox !== 'boolean'
        ) {
          infoData.settings[props.fieldConfig.field] = false;
        } else if (props.fieldConfig?.extra === 'switch') {
          infoData.settings[props.fieldConfig.field] = switchVal;
        } else {
          infoData.settings[props.fieldConfig.field] = values.state_checkbox;
        }
        if (initilized.current === 0) {
          props.onChange(
            {
              action: 'data',
              form: FIELD_NAME,
              data: infoData,
              errors,
            },
            true,
          );
          initilized.current = 1;
        } else {
          props.onChange({
            action: 'data',
            form: FIELD_NAME,
            data: infoData,
            errors,
          });
        }
      });

    // send once default data
    sendDefaults();
    return () => {
      sub.unsubscribe();
    };
  }, [props.fieldConfig, switchVal]);
  const formRef = useRef<any>();
  useEffect(() => {
    if (formRef && formRef.current !== undefined && props.validateForm !== 0) {
      formRef.current.submitForm();
    }
  }, [props.validateForm]);

  let isEditable = props.fieldConfig != null && props.fieldConfig.editable === true;
  if (isEditable) {
    if (props.deviceInfo.settings[`has_${props.fieldConfig.field}`] === false) {
      isEditable = false;
    }
  }

  const handleChangeSwitch = (event) => {
    setSwitchVal(event.target.checked);
  };

  return isEditable === true ? (
    <div>
      <Formik
        initialValues={{
          state_checkbox: props.fieldConfig?.default,
        }}
        innerRef={formRef}
        onSubmit={onSubmitForm}
      >
        {({
          errors, handleBlur, handleChange, touched, values,
        }) => {
          deb?.next({
            values,
            errors,
          });
          return (
            <form>
              <div className="text-fields-flex">
                <div>
                  {props.fieldConfig?.extra === 'switch' ? (
                    <FormControlLabel
                      control={(
                        <Switch
                          defaultChecked
                          checked={switchVal}
                          onChange={handleChangeSwitch}
                          name="checkedA"
                        />
                      )}
                      label={props.fieldConfig.labels}
                    />
                  ) : (
                    <FormControlLabel
                      label={props.fieldConfig.labels}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      control={(
                        <Checkbox
                          checked={
                            conButtonsTypesOfAlarms.includes(props.fieldConfig.field)
                            && typeof values.state_checkbox !== 'boolean'
                              ? false
                              : values.state_checkbox
                          }
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          name="state_checkbox"
                          onBlur={handleBlur}
                          color="primary"
                        />
                      )}
                    />
                  )}
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  ) : (
    <div />
  );
};
